import { AxiosError } from 'axios';

// 라운지 api는 문제가 발생해도 파트너센터 동작에 문제가 없기 때문에 이를 별도로 처리하기 위한 에러 객체
class LoungeApiError extends Error {
  private constructor(message: string, cause: AxiosError) {
    super(message, { cause });
  }

  static fromAxiosError(error: AxiosError) {
    const url = error.config?.url;
    if (!url) return undefined;

    if (url.includes('/api/public/bulletin/banner')) {
      return new LoungeApiError('라운지 api 에러: banner', error);
    }

    if (url.includes('/api/public/bulletin/uncheckedCount')) {
      return new LoungeApiError('라운지 api 에러: uncheckedCount', error);
    }

    return undefined;
  }
}

export default LoungeApiError;
